// Generated by scripts/discover.mjs. Don't edit: add or rename a file instead (CLAUDE.md).

/// <reference path="./virtual.d.ts" />

/** The features fetched when a screen first needs them: the top-level keys each holds, and how to load it per language. */
export const COPY_GROUPS = {
  "code": {
    keys: ["code"],
    load: {
      en: () => import("virtual:adea-copy/code.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/code.da").then((m) => m.default),
    },
  },
  "company-links": {
    keys: ["companyLinks"],
    load: {
      en: () => import("virtual:adea-copy/company-links.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/company-links.da").then((m) => m.default),
    },
  },
  "data": {
    keys: ["data"],
    load: {
      en: () => import("virtual:adea-copy/data.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/data.da").then((m) => m.default),
    },
  },
  "delivery": {
    keys: ["delivery"],
    load: {
      en: () => import("virtual:adea-copy/delivery.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/delivery.da").then((m) => m.default),
    },
  },
  "lists": {
    keys: ["lists"],
    load: {
      en: () => import("virtual:adea-copy/lists.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/lists.da").then((m) => m.default),
    },
  },
  "pages": {
    keys: ["pages", "routines"],
    load: {
      en: () => import("virtual:adea-copy/pages.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/pages.da").then((m) => m.default),
    },
  },
  "questions": {
    keys: ["questions"],
    load: {
      en: () => import("virtual:adea-copy/questions.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/questions.da").then((m) => m.default),
    },
  },
  "settings-brand": {
    keys: ["settingsBrand"],
    load: {
      en: () => import("virtual:adea-copy/settings-brand.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/settings-brand.da").then((m) => m.default),
    },
  },
  "settings-guard": {
    keys: ["settingsGuard"],
    load: {
      en: () => import("virtual:adea-copy/settings-guard.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/settings-guard.da").then((m) => m.default),
    },
  },
  "settings-money": {
    keys: ["settingsMoney"],
    load: {
      en: () => import("virtual:adea-copy/settings-money.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/settings-money.da").then((m) => m.default),
    },
  },
  "settings": {
    keys: ["settings"],
    load: {
      en: () => import("virtual:adea-copy/settings.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/settings.da").then((m) => m.default),
    },
  },
  "sharing-ui": {
    keys: ["sharingUi"],
    load: {
      en: () => import("virtual:adea-copy/sharing-ui.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/sharing-ui.da").then((m) => m.default),
    },
  },
  "sharing": {
    keys: ["sharing"],
    load: {
      en: () => import("virtual:adea-copy/sharing.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/sharing.da").then((m) => m.default),
    },
  },
  "staff": {
    keys: ["staff"],
    load: {
      en: () => import("virtual:adea-copy/staff.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/staff.da").then((m) => m.default),
    },
  },
  "understand": {
    keys: ["understand", "studying"],
    load: {
      en: () => import("virtual:adea-copy/understand.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/understand.da").then((m) => m.default),
    },
  },
  "webhooks": {
    keys: ["webhooks"],
    load: {
      en: () => import("virtual:adea-copy/webhooks.en").then((m) => m.default),
      da: () => import("virtual:adea-copy/webhooks.da").then((m) => m.default),
    },
  },
} as const;

export type CopyGroupId = keyof typeof COPY_GROUPS;
